---
label: History
category: sequences
icon: ClockIcon
keywords: [history, changes, edits, timeline, operations, log]
addedInVersion: "0.0.0"
---

# History

The History tab shows a timeline of every change made to a sequence, grouped by
date.

Open it from the right panel in the sequence viewer.

## Tracked Changes

- Insertions and deletions with position and base count
- Replacements showing old and new content
- DNA/RNA conversions
- Feature creation, updates, and deletion
- Metadata changes (name, description, organism, etc.)

